import ArgType from 'notebook/tables/excess/ArgType';
import FunctionCategory from 'notebook/tables/excess/FunctionCategory';
import {EvaluablePrimitiveSpreadsheetFunction} from 'notebook/tables/excess/FunctionConstants';
import divide from 'notebook/tables/excess/util/divide';
import filterNumbers from 'notebook/tables/excess/util/filterNumbers';
import sum from 'notebook/tables/excess/util/sum';

export default {
  name: 'AVERAGE',
  category: FunctionCategory.STATS,
  shortDescription: 'Average in a dataset, ignoring non-numerical data.',
  description: 'Returns the numerical average value in a dataset, ignoring text.',
  params: [
    {
      name: 'value',
      type: ArgType.any,
      description: 'The first value or range to consider when calculating the average value.',
    },
  ],
  repeatableLastParamType: ArgType.any,
  repeatableLastParamDescription:
    'Additional values or ranges to consider when calculating the average value.',

  eval: (...values): number => {
    const numberValues = filterNumbers(values);
    return divide(sum(numberValues), numberValues.length, 'AVERAGE');
  },
} satisfies EvaluablePrimitiveSpreadsheetFunction;
